import { render, staticRenderFns } from "./industryDetail.vue?vue&type=template&id=02fe96c6&scoped=true&"
import script from "./industryDetail.vue?vue&type=script&lang=js&"
export * from "./industryDetail.vue?vue&type=script&lang=js&"
import style0 from "./industryDetail.vue?vue&type=style&index=0&id=02fe96c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe96c6",
  null
  
)

export default component.exports